import { toBoolOrNull, toIntOrNull } from '@utils/parse';
import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import { DashRegistrationStep } from '@/types/dashboard';
import { defaultScreeningProgress } from '@/types/screening/screening-progress';
import type {
    IAssessHeartAttackFormValues,
    IAssessHeartAttackModel,
    IAssessHeartAttackSubmitResult,
} from '@/types/screening/assess-heart-attack';

const ASSESS_HEART_ATTACK_ENDPOINT = '/api/register/assess-heart-attack';

const defaultAssessHeartAttackModel: IAssessHeartAttackModel = {
    ...defaultScreeningProgress,
    currentRegistrationStep: DashRegistrationStep.AssessHeartAttack,
    hasHadHeartAttack: null,
    heartAttackRemissionStatus: null,
};

export const useAssessHeartAttack = (registrationId: number, editKey: string) => {
    const url = `${ASSESS_HEART_ATTACK_ENDPOINT}/${registrationId}/${editKey}`;

    const { model, isLoading, error } = useApiModel(url, defaultAssessHeartAttackModel);

    const { submit, isSubmitting, submitError } = useApiSubmit<
        IAssessHeartAttackFormValues,
        DashRegistrationStep,
        IAssessHeartAttackSubmitResult
    >(
        url,
        (values) => {
            const hasHadHeartAttack = toBoolOrNull(values.hasHadHeartAttack);
            const heartAttackRemissionStatus = hasHadHeartAttack === true ? toIntOrNull(values.heartAttackRemissionStatus) : null;

            return {
                hasHadHeartAttack,
                heartAttackRemissionStatus,
            };
        },
        (nextStep) => ({ nextStep }),
    );

    return { model, isLoading, error, submit, isSubmitting, submitError };
};
